import { jsx as t } from "react/jsx-runtime";
import { d as l, aq as s, ar as d } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as c } from "react";
import { stupidInvertClasses as n } from "../../utils/index.js";
import { ChildFilter as p } from "../../utils/ChildFilter/index.js";
import '../../assets/index13.css';const m = "_tooltip_xd40h_1", f = {
  tooltip: m
}, T = c(
  ({ placement: o = "top", __inverted: i, children: a }, r) => {
    const e = l(f.tooltip, i ? n() : void 0);
    return /* @__PURE__ */ t(s, { ref: r, placement: o, className: e, "data-component": "Tooltip", children: /* @__PURE__ */ t(p, { invalidChildren: ["a", "button", "iconbutton", "link"], children: a }) });
  }
), v = (o) => d({ ...o, closeDelay: 0, delay: o.delay === "immediate" ? 0 : 300 });
export {
  T as Tooltip,
  v as TooltipTrigger
};
